import userRouteConfig from './user/userRouteConfig';
import profileRouteConfig from './profile/profileRouteConfig';
import whatIfConfig from './whatIf/whatIfConfig';
import measurementUnitConfig from './measurementUnit/measurementUnitConfig';
import driverConfig from './driver/driverConfig';
import optimizerLogConfig from './optimizerLog/optimizerLogConfig';
import transformerConfig from './workflow/transformerConfig';
import modelConfig from './model/modelConfig';
import datasetConfig from './dataset/datasetConfig';
import modelAnnConfig from './modelAnn/modelAnnConfig';
import modelHysysConfig from './modelHysys/modelHysysConfig';
import modelPetrosimConfig from './modelPetrosim/modelPetrosimConfig';
import optimizationCaseConfig from './optimizationCase/optimizationCaseConfig';
import modelLummusConfig from './modelLummus/modelLummusConfig';
import modelSpreadsheetConfig from './modelSpreadsheet/modelSpreadsheetConfig';
import aspectConfig from './aspect/aspectConfig';
import driverLogConfig from './driverLog/driverLogConfig';
import modelExpressionConfig from './modelExpression/modelExpressionConfig';
import fittingCaseConfig from './fittingCase/fittingCaseConfig';
import taskManagerConfig from './taskManager/taskManagerConfig';
import fitterLogConfig from './fitterLog/fitterLogConfig';
import testConfig from './test/testConfig';
import optimizationPipelineConfig from './optimizationPipeline/optimizationPipelineConfig';
import optimizationPipelineV2Config from './optimizationPipelineV2/optimizationPipelineConfig';
import pictogramConfig from './pictogram/pictogramConfig';
import piMeasurementReaderConfig from './piMeasurementReader/piMeasurementReaderConfig';
import piAfEventReaderConfig from './piAfEventReader/piAfEventReaderConfig';
import labConnectionConfig from './labConnection/labConnectionConfig';
import piConnectionConfig from './piConnection/piConnectionConfig';
import labMeasurementReaderConfig from './labMeasurementReader/labMeasurementReaderConfig';
import modelWorkflowConfig from './modelWorkflow/modelWorkflowConfig';
import measurementConfig from './measurement/measurementConfig';
import schedulerConfig from './scheduler/schedulerConfig';
import modelLummus2Config from './modelLummus2/modelLummus2Config';
import modelOpcConfig from './modelOpc/modelOpcConfig';
import optimizerConfig from './optimizer/optimizerConfig';
import outlierDetectorConfig from './outlierDetector/outlierDetectorConfig';
import unitOptimizerConfig from './unitOptimizer/unitOptimizerConfig';
import modelValidationLogConfig from './modelValidationLog/modelValidationLogConfig';
import modelValidationConfig from './modelValidation/modelValidationConfig';
import unitOptimizerLogConfig from './unitOptimizerLog/unitOptimizerLogConfig';
import notificationConfig from './notification/notificationConfig';
import optimizationPipelineLogConfig from './optimizationPipelineLog/optimizationPipelineLogConfig';
import unitOptimizerOverviewConfig from './unitOptimizerOverview/unitOptimizerOverviewConfig';
import simulationMonitorConfig from './simulationMonitor/simulationMonitorConfig';
import simulationMonitorLogConfig from './simulationMonitorLog/simulationMonitorLogConfig';
import userGroupConfig from './userGroup/userGroupConfig';
import piWriterConfig from './piWriter/piWriterConfig';
import piWriterLogConfig from './piWriterLog/piWriterLogConfig';
import edtDynamicCheckConfig from './edtDynamicCheck/edtDynamicCheckConfig';
import edtDynamicCheckLogConfig from './edtDynamicCheckLog/edtDynamicCheckLogConfig';
import opcDaWriterConfig from './opcDaWriter/opcDaWriterConfig';
import opcDaWriterLogConfig from './opcDaWriterLog/opcDaWriterLogConfig';

const AdminConfig = {
	settings: { layout: { config: {} } },
	routes: [
		...userRouteConfig,
		...profileRouteConfig,
		...whatIfConfig,
		...measurementUnitConfig,
		...driverConfig,
		...optimizerLogConfig,
		...transformerConfig,
		...modelConfig,
		...datasetConfig,
		...modelAnnConfig,
		...modelHysysConfig,
		...modelPetrosimConfig,
		...modelLummusConfig,
		...modelLummus2Config,
		...modelOpcConfig,
		...modelSpreadsheetConfig,
		...optimizationCaseConfig,
		...aspectConfig,
		...driverLogConfig,
		...modelExpressionConfig,
		...fittingCaseConfig,
		...taskManagerConfig,
		...fitterLogConfig,
		...testConfig,
		...optimizationPipelineConfig,
		...optimizationPipelineV2Config,
		...pictogramConfig,
		...piMeasurementReaderConfig,
		...piAfEventReaderConfig,
		...labConnectionConfig,
		...piConnectionConfig,
		...labMeasurementReaderConfig,
		...modelWorkflowConfig,
		...measurementConfig,
		...schedulerConfig,
		...optimizerConfig,
		...outlierDetectorConfig,
		...unitOptimizerConfig,
		...modelValidationLogConfig,
		...modelValidationConfig,
		...unitOptimizerLogConfig,
		...notificationConfig,
		...optimizationPipelineLogConfig,
		...unitOptimizerOverviewConfig,
		...simulationMonitorConfig,
		...simulationMonitorLogConfig,
		...userGroupConfig,
		...piWriterConfig,
		...piWriterLogConfig,
		...edtDynamicCheckConfig,
		...edtDynamicCheckLogConfig,
		...opcDaWriterConfig,
		...opcDaWriterLogConfig
	]
};

export default AdminConfig;
